import { adminMutation } from "@/admin/utils/adminMutation.ts";
import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type {
    ElevatedUser,
    ElevatedUserDeleteBody,
    ElevatedUserRole,
    ElevatedUserUpsertBody,
} from "@warrenio/api-spec/spec.oats.gen";

export const elevatedUserRoles: ElevatedUserRole[] = ["admin", "admin-accountant"];

//#region Response
type Response = ElevatedUser[];
//#endregion

//#region Query and parameters
const queryKey: QueryKey = ["admin_users"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<Response> => {
            return getResponseData(await client.GET("/user-resource/admin/elevated_users", { signal }));
        },
    });
}
//#endregion

//#region Atoms
export const adminUsersQueryAtom = atomFromStandardQueryOptions(getQuery);
//#endregion

//#region Mutations

const entity = "Admin user";

export const adminUserCreateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "create",
    requestFn: async ({ body }: { body: ElevatedUserUpsertBody }) =>
        await apiClient.PUT("/user-resource/admin/elevated_users", {
            ...jsonEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

export const adminUserDeleteMutation = adminMutation((apiClient) => ({
    entity,
    operation: "delete",
    requestFn: async ({ body }: { body: ElevatedUserDeleteBody }) =>
        await apiClient.DELETE("/user-resource/admin/elevated_users", {
            ...jsonEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

//#endregion Mutations
